import type { EstimatedTimeName } from '@gat-ship/types'

/**
 * Seed data that backs the in-memory mock until the backend endpoints
 * land. Codes/labels follow the examples called out in the
 * Estimated time names feature brief.
 */
export const mockEstimatedTimeNames: EstimatedTimeName[] = [
  {
    id: '00000000-0000-0000-0000-000000000001',
    code: 'EAM',
    name: 'Early AM',
    referenceTime: '06:00:00',
    isInactive: false
  },
  {
    id: '00000000-0000-0000-0000-000000000002',
    code: 'AM',
    name: 'AM',
    referenceTime: '09:00:00',
    isInactive: false
  },
  {
    id: '00000000-0000-0000-0000-000000000003',
    code: 'Noon',
    name: 'Noon',
    referenceTime: '12:00:00',
    isInactive: false
  },
  {
    id: '00000000-0000-0000-0000-000000000004',
    code: 'PM',
    name: 'PM',
    referenceTime: '15:00:00',
    isInactive: false
  },
  {
    id: '00000000-0000-0000-0000-000000000005',
    code: 'LPM',
    name: 'Late PM',
    referenceTime: '20:00:00',
    isInactive: false
  }
]
